import { useMemo, useState } from 'react';

export const useEnergyDrawDataInitialiser = () => {
  const [energyDrawerData, setEnergyDrawerData] = useState({
    imageSrc: '',
    altText: '',
    energyRating: '',
  });
  const [energyDrawerIsOpen, setEnergyDrawerIsOpen] = useState(false);

  const returnValue = useMemo(
    () => ({
      energyDrawerData,
      energyDrawerIsOpen,
      setEnergyDrawerData,
      setEnergyDrawerIsOpen,
    }),
    [energyDrawerData, energyDrawerIsOpen]
  );

  return returnValue;
};
